import {Injectable} from '@angular/core';
import {GenericHandler} from '../generics/generic-handler';
import {UtilsService} from '../../utils/utils.service';
import {Auth2Service} from '../security/auth2.service';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {GenericDatagridService} from '../generics/generic-datagrid.service';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {FormFieldTextboxSupplier} from '../../suppliers/form-field-textbox-supplier';
import {FormFieldCheckboxSupplier} from '../../suppliers/form-field-checkbox-supplier';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {MotifNonConformiteDTO} from '../../dtos/motif-non-conformite-dto';
import {startCase as _startCase} from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class MotifsNonConformiteService   extends GenericHandler<MotifNonConformiteDTO> {

  motifsNonConfoEnvironnement:MotifNonConformiteDTO[];

  constructor(
    utils: UtilsService,
    auth2Svc: Auth2Service, router: Router, http: HttpClient, title: Title, private gds: GenericDatagridService) {
    super(utils, auth2Svc, router, http, title);

    this.getAllFromEnvironnement();

    this.environnement$.subscribe(() => {
      this.getAllFromEnvironnement();
    });
  }

  getTotalRecordsLabel(): string {
    return _startCase(this.getEntityName());
  }


  createEmptyDTO(): MotifNonConformiteDTO {
    return undefined;
  }

  getAllFromEnvironnement(): void {

    console.log("MotifsNonConformiteService#getAllFromEnvironnement()");
    this.gds.getAll(this.getEntityName(), ['libelle,asc'], true)
      .subscribe(response => {
        this.motifsNonConfoEnvironnement = [];

        if (!this.utils.isCollectionNullOrEmpty(response.resultList)) {
          this.motifsNonConfoEnvironnement = response.resultList.map(item => {
            item.libelle = item.libelle.toUpperCase();
            return item;
          });
        }

        this.announceObjects(this.motifsNonConfoEnvironnement);

      });


  }

  getCreateNewObjectLabel(): string {
    return "CRÉER UN MOTIF DE NON CONFORMITE";
  }

  getEditObjectLabel(data: MotifNonConformiteDTO): string {
    return "MODIFIFER UN MOTIF DE NON CONFORMITE";
  }

  getEntityName(): string {
    return "motifNonConformite";
  }

  getFields(dto: MotifNonConformiteDTO): FormFieldBaseSupplier<any>[] {

    // Par défaut un MotifNonConformite est actif.
    if (this.utils.isNullOrEmpty(dto) || dto.id == 0 || dto.id == undefined) {
      dto = new MotifNonConformiteDTO();
      dto.actif = true;
    }

    const readonly =  !this.canModifySite(dto);

    let formFields: FormFieldBaseSupplier<any>[] = [

      this.createFormFieldBaseSupplierForSite(dto, 1),

      new FormFieldTextboxSupplier({
        key: 'libelle',
        label: 'Libellé',
        readonly: false,
        minLength: 2,
        maxLength: 100,
        value: dto.libelle,
        required: true,
        excelType:'string',
        order: 2
      }),



      new FormFieldTextboxSupplier({
        key: 'code',
        label: 'Code',
        readonly: false,
        value: dto.code,
        maxLength: 50,
        required: true,
        excelType:'string',
        order: 4
      }),

      new FormFieldCheckboxSupplier({
        key: 'actif',
        label: 'Actif',
        readonly: !this.canModify(dto),
        value: dto.actif,
        required: false,
        excelType:'boolean',
        order: 6
      }),


      new FormFieldTextboxSupplier({
        key: 'id',
        type: 'hidden',
        value: dto.id,
        order: 7
      }),


    ];

    return formFields.sort((a, b) => a.order - b.order);
  }


  getHelp(): DialogMsgSupplier {
    return undefined;
  }

  getOas(): boolean {
    return false;
  }

  getSort(): string[] {
    return ['libelle,asc'];
  }

  getTitle(): string {
    return "GESTION DES MOTIFS DE NON CONFORMITE";
  }
}
